export default {"src":"/_next/static/media/srn.20b8b280.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};